import React from "react";
import IconStyles, { IconStyle } from "../../types/enums/IconStyles";

interface DialogOKProps {
    children?: any;
    icon?: string;
    text?: string;
    left?: boolean;
    hidden?: boolean;
    disabled?: boolean;
    secure?: boolean;
    iconStyle?: IconStyle;
    tooltip?: string;
    onClick?: Function;
}

class DialogOK extends React.Component<DialogOKProps> {
    onClick(event) {
        this.props.onClick(event);
    }

    render() {
        let iconStyle = this.props.iconStyle ?? IconStyles.Normal;

        return (
            <button
                className={`dialog-close dialog-ok no-image${
                    this.props.left ? " left" : ""
                }`}
                style={{
                    display: this.props.hidden === true ? "none" : "initial",
                }}
                disabled={this.props.disabled}
                data-tip={this.props.tooltip}
                onClick={ev => this.onClick(ev)}>
                {this.props.secure && <i className={iconStyle}>lock</i>}
                {this.props.icon && <i>{this.props.icon}</i>}
                <span>{this.props.text ?? "OK"}</span>
            </button>
        );
    }
}

export default DialogOK;
